import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

/**
 * EmptyState — shared empty state component.
 *
 * Props:
 *   icon:        Lucide icon name string (default: 'Inbox')
 *   title:       heading text
 *   description: body text
 *   ctaLabel:    optional CTA button label
 *   ctaAction:   optional CTA button onClick handler
 *   ctaIcon:     optional icon name for CTA button (default: 'Plus')
 *   className:   extra wrapper classes
 */
const EmptyState = ({
  icon = 'Inbox',
  title = 'Nothing here yet',
  description = '',
  ctaLabel = '',
  ctaAction = null,
  ctaIcon = 'Plus',
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-4 text-center ${className}`}>
      <div className="flex items-center justify-center w-20 h-20 bg-accent/10 rounded-full mb-5">
        <Icon name={icon} size={36} color="var(--color-accent)" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-sm mb-6 leading-relaxed">{description}</p>
      )}
      {ctaLabel && ctaAction && (
        <Button
          variant="default"
          iconName={ctaIcon}
          iconPosition="left"
          onClick={ctaAction}
        >
          {ctaLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
